import React from "react";

export default function Buttons () {
    return(
        <>
            <button>All</button>
            <button>Active</button>
            <button>Done</button>
        </>
    )
}